// The Rest API is the authoritative source on how topic-names are generated.
import memoize from 'lodash/memoize';

import keycloakService from '../keycloak_service';
import { sinatraOrigin } from '../config';

export const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

const get_topic_name = async (workspace_id, pipeline_name) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify({
      'workspace_id': workspace_id,
      'pipeline_name': pipeline_name,
    }),
  };

  return postToApi('v1/api/plateau/get_topic_name', fetchOptions);
};

export default memoize(get_topic_name, (a, b) => `${a}-${b}`);
